"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagSX = function FlagSX(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H209.54a7.06,7.06,0,0,1,7.06,7.06V12.18H-193V-114.94a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V12.18H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-190.4,144.65,5.08,16.58a5.27,5.27,0,0,0,0-8.81L-190.4-120.29a7,7,0,0,0-2.6,5.35V139.3a7,7,0,0,0,2.6,5.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-98.43-15.08A22.17,22.17,0,0,1-120.6,7.1a22.17,22.17,0,0,1-22.17-22.18A22.17,22.17,0,0,1-120.6-37.25,22.17,22.17,0,0,1-98.43-15.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-93.49,5.46c.09,2.7.38,5.47.67,8.15,1.1,10.53,2.06,19.63-8.05,23.16a51.45,51.45,0,0,1-8.8,1.75c-4.52.65-8.57,1.23-10.92,2.87-2.36-1.64-6.41-2.22-10.93-2.87a51.52,51.52,0,0,1-8.79-1.75c-10.12-3.53-9.16-12.63-8.05-23.16.28-2.68.57-5.45.66-8.15a86.75,86.75,0,0,0-3.11-24.16,24.13,24.13,0,0,0,9.62,1.77c1.72,0,3.65-.28,5.71-.53,4.67-.6,10-1.27,14.21.4l.68.31.68-.31c4.24-1.67,9.54-1,14.21-.4,2,.25,4,.5,5.71.53a24,24,0,0,0,9.61-1.77A87.12,87.12,0,0,0-93.49,5.46Zm0,0",
    transform: "translate(194 123)",
    fill: "#8cd7ff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-89.79,5.34c-.45-13.51,4.16-27.07,4.21-27.21l-2.91-2a19.18,19.18,0,0,1-11.43,3.29c-1.53,0-3.37-.27-5.31-.51-4.9-.62-10.41-1.32-15.36.38-5-1.7-10.47-1-15.36-.38-2,.24-3.79.48-5.32.51a19.18,19.18,0,0,1-11.43-3.29l-2.91,2c.05.14,4.66,13.7,4.21,27.21-.08,2.56-.36,5.27-.64,7.89-1.11,10.56-2.37,22.54,10.51,27A61.15,61.15,0,0,0-132,42.18c9.94,1.65,11.45,4.19,11.45,4.19s1.5-2.54,11.44-4.19a61.39,61.39,0,0,0,9.49-1.92c12.88-4.49,11.62-16.47,10.51-27-.28-2.62-.56-5.33-.64-7.89Zm-3.7.12c.09,2.7.38,5.47.67,8.15,1.1,10.53,2.06,19.63-8.05,23.16a51.45,51.45,0,0,1-8.8,1.75c-4.52.65-8.57,1.23-10.92,2.87-2.36-1.64-6.41-2.22-10.93-2.87a51.52,51.52,0,0,1-8.79-1.75c-10.12-3.53-9.16-12.63-8.05-23.16.28-2.68.57-5.45.66-8.15a86.75,86.75,0,0,0-3.11-24.16,24.13,24.13,0,0,0,9.62,1.77c1.72,0,3.65-.28,5.71-.53,4.67-.6,10-1.27,14.21.4l.68.31.68-.31c4.24-1.67,9.54-1,14.21-.4,2,.25,4,.5,5.71.53a24,24,0,0,0,9.61-1.77A87.12,87.12,0,0,0-93.49,5.46Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-101.54,28.18V20h1.4V17.63h-3.42V9.27h3.42L-115.75-1.79V-5.95h2.17l-7-5-7,5h2.17v4.16L-141,9.27h3.42v8.36H-141V20h1.4v8.14h-2V31.7H-99.5V28.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-140.84-5.16a3.79,3.79,0,0,0,.11,3.35,3.79,3.79,0,0,0,2.48-2.25,3.83,3.83,0,0,0-.11-3.35,3.77,3.77,0,0,0-2.48,2.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-138.43-4.79a3.8,3.8,0,0,0,2.14,2.58,3.82,3.82,0,0,0,.59-3.29,3.8,3.8,0,0,0-2.14-2.58,3.82,3.82,0,0,0-.59,3.29Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-134.67-6.84a3.82,3.82,0,0,0,3.34-.27,3.8,3.8,0,0,0-2.36-2.37,3.78,3.78,0,0,0-3.34.26,3.83,3.83,0,0,0,2.36,2.38Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-133.54-9a3.77,3.77,0,0,0,2.21-2.51,3.83,3.83,0,0,0-3.35-.07A3.8,3.8,0,0,0-136.89-9a3.8,3.8,0,0,0,3.35.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-141.42-7.89a3.79,3.79,0,0,0,1.67-2.91,3.84,3.84,0,0,0-3.3.61,3.8,3.8,0,0,0-1.66,2.91,3.79,3.79,0,0,0,3.29-.61Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-142.29-9.43a6.29,6.29,0,0,0,4.61.8,6.16,6.16,0,0,0-3-3.57,6.19,6.19,0,0,0-4.61-.8,6.21,6.21,0,0,0,3,3.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#41aa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-135.51-7.55a1.16,1.16,0,0,0-1.12-1.15,1.14,1.14,0,0,0-1.15-1.11,1.16,1.16,0,0,0-1.15,1.11A1.15,1.15,0,0,0-140-7.55a1.15,1.15,0,0,0,1.11,1.15,1.16,1.16,0,0,0,1.15,1.12,1.15,1.15,0,0,0,1.15-1.12,1.16,1.16,0,0,0,1.12-1.15Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-137.1-7.55a.67.67,0,0,1-.68.68.68.68,0,0,1-.68-.68.68.68,0,0,1,.68-.68.67.67,0,0,1,.68.68Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-139.13-8.7a1,1,0,0,0-.91-.94,1,1,0,0,0-1-.91,1,1,0,0,0-.94.91,1,1,0,0,0-.92.94,1,1,0,0,0,.92.95,1,1,0,0,0,.94.92,1,1,0,0,0,1-.92,1,1,0,0,0,.91-.95Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-140.43-8.7a.56.56,0,0,1-.56.56.56.56,0,0,1-.56-.56.56.56,0,0,1,.56-.56.56.56,0,0,1,.56.56Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-135.66-10.3a.69.69,0,0,0-.66-.68.69.69,0,0,0-.68-.66.68.68,0,0,0-.68.66.68.68,0,0,0-.66.68.69.69,0,0,0,.66.69.68.68,0,0,0,.68.66.68.68,0,0,0,.68-.66.69.69,0,0,0,.66-.69Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-136.6-10.29a.4.4,0,0,1-.4.4.4.4,0,0,1-.4-.4.4.4,0,0,1,.4-.41.4.4,0,0,1,.4.41Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-138.2-11.45a.69.69,0,0,0-.67-.68.68.68,0,0,0-.68-.66.68.68,0,0,0-.68.66.68.68,0,0,0-.66.68.69.69,0,0,0,.66.68.69.69,0,0,0,.68.66.68.68,0,0,0,.68-.66.69.69,0,0,0,.67-.68Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-139.15-11.45a.4.4,0,0,1-.4.4.4.4,0,0,1-.4-.4.4.4,0,0,1,.4-.41.4.4,0,0,1,.4.41Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-108.68-1.3h12.82a7,7,0,0,0-4.43-3.92A19.55,19.55,0,0,0-100-8.3c0-3.87-1-7-2.22-7s-2.21,3.14-2.21,7a19.6,19.6,0,0,0,.23,3.08,7,7,0,0,0-4.43,3.92Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-120.59,61.61a49,49,0,0,1-49-49h9.24a39.78,39.78,0,0,0,39.74,39.73A39.78,39.78,0,0,0-80.86,12.64h9.24a49,49,0,0,1-49,49Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-102.44-31.12h-8A1.45,1.45,0,0,0-109-32.57,1.45,1.45,0,0,0-110.43-34h-10.16A1.45,1.45,0,0,0-122-32.57a1.45,1.45,0,0,0,1.46,1.45h-18.15a2.18,2.18,0,0,0-2.18,2.18,2.18,2.18,0,0,0,2.18,2.18h6.53a1.45,1.45,0,0,0-1.45,1.45,1.45,1.45,0,0,0,1.45,1.45h13.07a1.45,1.45,0,0,0,1.45-1.45,1.45,1.45,0,0,0-1.45-1.45h16.7a2.18,2.18,0,0,0,2.17-2.18,2.18,2.18,0,0,0-2.17-2.18Zm0,0",
    transform: "translate(194 123)",
    fill: "#c87878"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagSX;
exports["default"] = _default;